module.exports = __webpack_public_path__ + "img/list-layout.a9765b3b.svg";